module.exports = __webpack_public_path__ + "static/img/43.8466ddba.png";